<script>
  import { navigationStore } from "../stores/navigationStore";
</script>

<nav>
  <ul>
    <li>
      <a
        class:active={$navigationStore.home}
        on:click={navigationStore.scrollToTop}
      >
        Home
      </a>
    </li>
    <li>
      <a
        class:active={$navigationStore.about}
        on:click={() => navigationStore.scrollTo("#about")}
      >
        About
      </a>
    </li>
    <li>
      <a
        class:active={$navigationStore.benefits}
        on:click={() => navigationStore.scrollTo("#benefits")}>Benefits</a
      >
    </li>
    <li>
      <a
        class:active={$navigationStore.features}
        on:click={() => {
          navigationStore.scrollTo("#features");
        }}>Features</a
      >
    </li>
    <li>
      <a
        class:active={$navigationStore.contacts}
        on:click={() => {
          navigationStore.scrollTo("#contacts");
        }}>Contacts</a
      >
    </li>
  </ul>
</nav>

<style>
  nav {
    margin: 0 32px;
    margin-right: 90px;
  }
  ul {
    display: flex;
    align-items: center;
    list-style: none;
  }
  li {
    margin-left: 40px;
    margin-right: 40px;
  }

  li:hover {
    transform: scale(0.97);
  }

  li:hover a {
    text-decoration: underline;
  }

  li:first-of-type {
    margin-left: 0;
  }

  li:last-of-type {
    margin-right: 0;
  }

  .active {
    color: var(--primary-color);
  }

  a {
    cursor: pointer;
    text-decoration: none;
    color: inherit;
    font-size: 16px;
  }
</style>
